const teamRoute = {
  BASE_PATH: "/team-management/team",
  detailPath: function (id: string | number) {
    return `${this.BASE_PATH}/${id}`;
  },
  addPath: function () {
    return this.BASE_PATH + "/create";
  },
  kpiDetailPath: function (id: string | number) {
    return `${this.BASE_PATH}/${id}/kpi`;
  },
  editPath: function (id: number | string) {
    return `${this.BASE_PATH}/${id}/edit`;
  },
};

export default teamRoute;
